import {
  StepperDescription,
  StepperIndicator,
  StepperItem,
  StepperRoot,
  StepperTitle,
  StepperTrigger,
} from './StepperElements.jsx';

export interface Step {
  title: string;
  description?: string;
  disabled?: boolean;
}
export interface StepperProps extends React.ComponentProps<'div'> {
  activeStep: number;
  steps: Step[];
  handleStep?: (step: number) => void;
  completedStep?: { [k: number]: boolean };
  isStepFailed?: (step: number) => boolean;
}

function Stepper({
  steps,
  activeStep,
  isStepFailed,
  handleStep,
  completedStep,
  className,
}: Readonly<StepperProps>) {
  const handleStepClick = (step: number) => {
    handleStep?.(step);
  };
  const isCompleted = (index: number) => {
    if (isStepFailed?.(index)) {
      return false;
    }
    if (completedStep?.[index]) {
      return true;
    }
  };

  return (
    <StepperRoot
      defaultValue={activeStep}
      value={activeStep}
      onValueChange={handleStepClick}
      className={className}
    >
      {steps.map((step, index) => (
        <StepperItem
          key={step.title}
          step={index}
          completed={isCompleted(index)}
          error={isStepFailed?.(index)}
          disabled={step.disabled}
        >
          <StepperTrigger
            disabled={step.disabled}
            onClick={() => handleStep?.(index)}
          >
            <StepperIndicator />
          </StepperTrigger>

          <div className="flex min-w-0 flex-col items-start">
            <StepperTitle>{step.title}</StepperTitle>
            <StepperDescription>{step.description}</StepperDescription>
          </div>

          {index < steps.length - 1 && (
            <hr className="h-px w-full min-w-10 border-border-secondary" />
          )}
        </StepperItem>
      ))}
    </StepperRoot>
  );
}

export default Stepper;
